
























































import Vue from 'vue';
import {mapActions} from 'vuex';
import {WeaponCosmetic} from '@/enums/WeaponCosmetic';
import {CharacterCosmetic} from '@/enums/CharacterCosmetic';

enum NonSeriesItem {
  ITEM_WEAPON_RENAME = 1,
  ITEM_CHARACTER_RENAME,
  ITEM_CHARACTER_TRAITCHANGE_FIRE,
  ITEM_CHARACTER_TRAITCHANGE_EARTH,
  ITEM_CHARACTER_TRAITCHANGE_WATER,
  ITEM_CHARACTER_TRAITCHANGE_LIGHTNING,
  ITEM_SHIELD = 9,
}

enum SeriesItem {
  ITEM_COSMETIC_WEAPON = 7,
  ITEM_COSMETIC_CHARACTER = 8,
}

interface SelectedNonSeriesItem {
  id?: NonSeriesItem;
  price?: number;
}

interface SelectedSeriesItem {
  id?: SeriesItem;
  prices: number[];
}


interface StoreMappedActions {
  setFlatPriceOfItem(payload: { itemIndex: NonSeriesItem, price: number }): Promise<void>;

  setFlatPriceOfItemSeries(payload: { itemIndex: SeriesItem, indices: WeaponCosmetic[] | CharacterCosmetic[], prices: number[] }): Promise<void>;
}

interface Data {
  selectedNonSeriesItem: SelectedNonSeriesItem;
  selectedSeriesItem: SelectedSeriesItem;
  nonSeriesItems: NonSeriesItem[];
  seriesItems: SeriesItem[];
  weaponCosmetics: WeaponCosmetic[];
  characterCosmetics: CharacterCosmetic[];
  isLoading: boolean;
}

export default Vue.extend({
  data() {
    return {
      selectedNonSeriesItem: {
        id: undefined,
        price: undefined,
      },
      selectedSeriesItem: {
        id: undefined,
        prices: [],
      },
      nonSeriesItems: [
        NonSeriesItem.ITEM_WEAPON_RENAME,
        NonSeriesItem.ITEM_CHARACTER_RENAME,
        NonSeriesItem.ITEM_CHARACTER_TRAITCHANGE_FIRE,
        NonSeriesItem.ITEM_CHARACTER_TRAITCHANGE_EARTH,
        NonSeriesItem.ITEM_CHARACTER_TRAITCHANGE_WATER,
        NonSeriesItem.ITEM_CHARACTER_TRAITCHANGE_LIGHTNING,
        NonSeriesItem.ITEM_SHIELD,
      ],
      seriesItems: [
        SeriesItem.ITEM_COSMETIC_WEAPON,
        SeriesItem.ITEM_COSMETIC_CHARACTER,
      ],
      weaponCosmetics: [
        WeaponCosmetic.GRAYSCALE,
        WeaponCosmetic.CONTRAST,
        WeaponCosmetic.SEPIA,
        WeaponCosmetic.INVERT,
        WeaponCosmetic.BLUR,
        WeaponCosmetic.FIRE_GLOW,
        WeaponCosmetic.EARTH_GLOW,
        WeaponCosmetic.LIGHTNING_GLOW,
        WeaponCosmetic.WATER_GLOW,
        WeaponCosmetic.RAINBOW_GLOW,
        WeaponCosmetic.DARK_GLOW,
        WeaponCosmetic.GHOST,
        WeaponCosmetic.POLICE,
        WeaponCosmetic.NEON_BORDER,
        WeaponCosmetic.ROTATING_NEON_BORDER,
        WeaponCosmetic.DIAMOND_BORDER,
        WeaponCosmetic.GOLD_BORDER,
        WeaponCosmetic.SILVER_BORDER,
        WeaponCosmetic.BRONZE_BORDER,
      ],
      characterCosmetics: [
        CharacterCosmetic.GRAYSCALE,
        CharacterCosmetic.CONTRAST,
        CharacterCosmetic.SEPIA,
        CharacterCosmetic.INVERT,
        CharacterCosmetic.BLUR,
        CharacterCosmetic.FIRE_GLOW,
        CharacterCosmetic.EARTH_GLOW,
        CharacterCosmetic.LIGHTNING_GLOW,
        CharacterCosmetic.WATER_GLOW,
        CharacterCosmetic.RAINBOW_GLOW,
        CharacterCosmetic.DARK_GLOW,
        CharacterCosmetic.GHOST,
        CharacterCosmetic.POLICE,
        CharacterCosmetic.NEON_BORDER,
        CharacterCosmetic.DIAMOND_BORDER,
        CharacterCosmetic.GOLD_BORDER,
        CharacterCosmetic.SILVER_BORDER,
        CharacterCosmetic.BRONZE_BORDER,
      ],
      isLoading: false,
      SeriesItem,
      NonSeriesItem,
      WeaponCosmetic,
      CharacterCosmetic,
    } as Data;
  },

  computed: {
    setFlatPriceOfNonSeriesItemButtonDisabled(): boolean {
      return this.selectedNonSeriesItem.id === undefined
        || this.selectedNonSeriesItem.price === undefined
        || this.isLoading;
    },

    setFlatPriceOfSeriesItemButtonDisabled(): boolean {
      return this.selectedSeriesItem.prices.length === 0
        || this.isLoading;
    },
  },

  methods: {
    ...mapActions([
      'setFlatPriceOfItem',
      'setFlatPriceOfItemSeries',
    ]) as StoreMappedActions,

    async setPriceOfNonSeriesItem() {
      if (this.setFlatPriceOfNonSeriesItemButtonDisabled) return;
      try {
        this.isLoading = true;
        await this.setFlatPriceOfItem({
          itemIndex: this.selectedNonSeriesItem.id!,
          price: this.selectedNonSeriesItem.price!,
        });
        this.selectedNonSeriesItem.id = undefined;
        this.selectedNonSeriesItem.price = undefined;
      } finally {
        this.isLoading = false;
      }
    },

    async setPriceOfSeriesItems() {
      if (this.setFlatPriceOfSeriesItemButtonDisabled) return;
      try {
        this.isLoading = true;
        let indices = [] as CharacterCosmetic[] | WeaponCosmetic[];
        if (this.selectedSeriesItem.id === SeriesItem.ITEM_COSMETIC_WEAPON) {
          indices = this.weaponCosmetics.filter((cosmetic: WeaponCosmetic, index: number) => this.selectedSeriesItem.prices[index]);
        } else if (this.selectedSeriesItem.id === SeriesItem.ITEM_COSMETIC_CHARACTER) {
          indices = this.characterCosmetics.filter((cosmetic: CharacterCosmetic, index: number) => this.selectedSeriesItem.prices[index]);
        }
        const prices = this.selectedSeriesItem.prices.filter(price => price);
        await this.setFlatPriceOfItemSeries({
          itemIndex: this.selectedSeriesItem.id!,
          indices,
          prices
        });
        this.selectedSeriesItem.id = undefined;
        this.selectedSeriesItem.prices = [];
      } finally {
        this.isLoading = false;
      }
    },

    clearInputs() {
      this.selectedNonSeriesItem.id = undefined;
      this.selectedNonSeriesItem.price = undefined;
    }
  },
});
